import React from 'react';
import './styles/components.css';

const Modal = ({ title, children, onClose, actions }) => (
  <div className="modal-overlay">
    <div className="modal-content" style={{ position: 'relative' }}>
      <button
        type="button"
        className="modal-close"
        onClick={onClose}
        aria-label="Cerrar"
      >
        ×
      </button>
      <h2>{title}</h2>
      <div className="modal-body">{children}</div>
      {actions && <div className="modal-actions">{actions}</div>}
    </div>
  </div>
);

export default Modal;
